import script from "./ItemRemarksLog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemRemarksLog.vue?vue&type=script&setup=true&lang=ts"

import "./ItemRemarksLog.vue?vue&type=style&index=0&id=578ce165&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-578ce165"]])

export default __exports__